import moment from "moment-timezone";
import { azureConfig } from "client.config";
import i18n from "../../../i18n";

var currentLang = i18n.language;
currentLang = currentLang.split("-")[0];

export async function sendMailConfirmation(
  state,
  setState,
  actions,
  emailId,
  organizationId,
  oBranchId,
  language
) {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const currentTime = moment().tz(timezone).format("YYYY-MM-DDTHH:mm:ss");

  const expiryTime = moment(currentTime)
    .add(1, "d")
    .format("YYYY-MM-DDTHH:mm:ss");

  const data = {
    applicationInformation: {
      name: "Self-Service",
      url:
        process.env.AZURE_AUTH_REDIRECT_URL +
        "/create-profile?email=" +
        emailId +
        "&organizationId=" +
        organizationId +
        "&contextId=" +
        oBranchId +
        "&verificationExpirationDateTime=" +
        expiryTime +
        "&lng=" + 
        language,
    },
    userContact: {
      emailContact: {
        purpose: "Work",
        emailAddress: emailId,
      },
    },
    userOrganizationInformation: {
      organizationId: organizationId,
      branch: {
        contextId: oBranchId,
      },
    },
    userLanguageCode: currentLang,
    userSubscriptions: [
      {
        status: "Approved",
        billableItemUri: "/billable-items/9c8fcef6-849c-4788-8877-29929fa984bd",
      },
    ],
  };
  const command = "verify/mail";
	return await actions.postNodeCallBack(state, setState, actions, command, data);
}

export async function CallOnBoard(state, setState, actions, triageRequests, doBValue) {
  triageRequests.customerOf =
    "/organizations/" +
    triageRequests.SignUpOrganizationId +
    "/branches/" +
    triageRequests.SignUpOBranchId;

  var effectiveFrom;
  var effectiveTo;
  if (triageRequests.profile && triageRequests.profile.effectFrom) {
    effectiveFrom = actions.generalDate({
      dateVal: triageRequests.profile.effectFrom.trim(),
    });
  } else {
    effectiveFrom = null;
  }
  if (triageRequests.profile && triageRequests.profile.effectTo) {
    effectiveTo = actions.generalDate({
      dateVal: triageRequests.profile.effectTo.trim(),
    });
  } else {
    effectiveTo = null;
  }

  var firstName =
    triageRequests.createUser && triageRequests.createUser.first.trim();
  var secondName =
    triageRequests.createUser && triageRequests.createUser.last.trim();
  var gender = triageRequests.userGender;
  var emailId =
    triageRequests.mailValidation && triageRequests.mailValidation.email.trim();
  var password =
    triageRequests.createUser &&
    triageRequests.createUser.confirmPassword.trim();
  var policyNo = triageRequests.profile && triageRequests.profile.policy.trim();
  var phoneNo = triageRequests.profile && triageRequests.profile.phone.trim();

  var userInformation = {
    legalGivenName: firstName,
    familyName: secondName,
    gender: gender,
    dateOfBirth: doBValue,
    associatedEntityUris: [
      {
        role: "CustomerOf",
        targetEntityUri: triageRequests.customerOf,
      },
    ],
  };

  var userIdentification = {
    type: "Azure AD B2C",
    scope: azureConfig.tenantId,
    identityProperties: [
      {
        keyName: "displayName",
        keyValue: firstName + " " + secondName,
      },
      {
        keyName: "givenName",
        keyValue: firstName,
      },
      {
        keyName: "surname",
        keyValue: secondName,
      },
      {
        keyName: "identity.signInType",
        keyValue: "emailAddress",
      },
      {
        keyName: "identity.issuerAssignedId",
        keyValue: emailId,
      },
      {
        keyName: "password",
        keyValue: password,
      },
    ],
  };

  var userLocation = [
    {
      associatedEntityUris: [
        {
          role: "IsHomeLocationOf",
        },
      ],

      addressInformation: {
        addressRole: "Home",
        lineAddress1: triageRequests.street,
        lineAddress2: triageRequests.street_number,
        city: triageRequests.city,
        province: triageRequests.province,
        country: triageRequests.country,
        postalCode: triageRequests.postalCode,
      },
    },
  ];

  var userContact = [
    {
      type: "Personal",
      phoneContact: {
        purpose: "Mobile",
        phoneNumber: phoneNo,
      },
      emailContact: {
        purpose: "Work",
        emailAddress: emailId,
      },
    },
  ];

  var userInsurance = [
    {
      parties: [
        {
          role: "HasPrimarySubjectOf",
        },
        {
          role: "IsIssuedBy",
          partyUri: triageRequests.customerOf,
        },
      ],
      applicablePeriod: {
        startDateTime: effectiveFrom,
        endDateTime: effectiveTo,
      },
      externalIdentifiers: [
        {
          identifierPropertyValue: policyNo,
          identifierProperyName: "PolicyNumber",
        },
      ],
    },
  ];

  var userOrg = {
    OrganizationId: triageRequests.SignUpOrganizationId,
    branch:{
      contextId:triageRequests.SignUpOBranchId
    }
  };

  var userSubscription = [
    {
      effectiveDateTime: effectiveFrom,
      expiryDateTime: effectiveTo,
      status: "Approved",
      billableItemUri: "/billable-items/9c8fcef6-849c-4788-8877-29929fa984bd",
    },
  ];

  const data = {
    userLanguageCode:currentLang,
    userPersonInformation: userInformation,
    userIdentityInformation: userIdentification,
    userLocations: userLocation,
    userContacts: userContact,
    userContracts: userInsurance,
    userOrganizationInformation: userOrg,
    userSubscriptions: userSubscription,
  };

  const command = "create/onboard";
	return await actions.postNodeCallBack(state, setState, actions, command, data);
}
